import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import store from "/WebInterface/new-ui/store/index.js";
import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

// cspell:disable
const icons = {
  default: "asterisk",
  copydirectlink: "copy",
  admin: "user",
  zip: "save",
  download: "download",
  options: "cog",
  search: "search",
  paste: "paste",
  copy: "copy",
  cut: "cut",
  upload: "upload",
  rename: "edit",
  delete: "trash",
  showbasket: "tasks",
  updatekeywords: "tags",
  slideshow: "picture",
  login: "lock",
  logout: "unlock",
  syncmanager: "user-md",
  csvexport: "download-alt",
  subscribetoevents: "envelope",
  addbasket: "plus-sign",
  custom: "magic",
  share: "share",
  mkdir: "folder-close",
};

/**
 * link
 * tabindex
 * i18nkey
 * label
 */

const topNavButtonTemplate = htmlE`
  <a href="${"link"}"
    data-link="${"isLink"}"
    ${"target"}
    tabindex="0"
    data-command="${"command"}"
    class="navbar-item-label"
    tabindex="${"tabindex"}"
    meta='${"key"}'>
    ${({ hideMenuBarIcon, icon, customImageUrl }) =>
      !hideMenuBarIcon
        ? customImageUrl
          ? `<w-image theme-specific="true" class="custom-icon" alt="custom-icon" src="/WebInterface/images/${customImageUrl}"></w-image>`
          : `<i class="icon-${icon}"></i>`
        : ""}
    ${({ hotKeyHTML, label }) => {
      if (label && hotKeyHTML) {
        return `<div label='${label}' class="is-hidden hotkey-template">${hotKeyHTML}</div>`;
      }
    }}
    ${({ command, i18nkey, label }) => {
      if (command === "alert(1)") {
        return "";
      }
      return `<span class="header-button-label" data-i18n-key="${i18nkey}">${label}</span>`;
    }}
  </a>`;

/**
 * tabindex
 * i18nkey
 * label
 * children
 */

const topNavButtonGroupRootTemplate = htmlE`
  <div tabindex="${"tabindex"}" class="dropdown">
    <button tabindex="0" type="button" meta="${"key"}" class="primary-button is-bg-none navbar-item-label dropdown-trigger">
      ${({ hideMenuBarIcon, icon, customImageUrl }) =>
        !hideMenuBarIcon
          ? customImageUrl
            ? `<w-image theme-specific="true" class="custom-icon" alt="custom-icon" src="/WebInterface/images/${customImageUrl}"></w-image>`
            : `<i class="icon-${icon}"></i>`
          : ""}
      <span data-i18n-key="${"i18nkey"}">${"label"}</span>
      ${({ hideMenuBarIcon }) =>
        !hideMenuBarIcon
          ? `<i class="icon-chevron-down ml-2"></i>`
          : `<span></span>`}
    </button>
    <div class="dropdown-menu" id="dropdown_${"index"}">
      <div class="dropdown-content">${"children"}</div>
    </div>
  </div>`;

const readPrivs = [
  "copydirectlink",
  "custom",
  "addbasket",
  "csvexport",
  "downloadkeywords",
  "explorezip",
  "login",
  "logout",
  "reportaproblem",
  "showbasket",
  "gethistory",
  "subscribetoevents",
  "options",
  "zipitems",
];

const getHotkeys = (strings) => {
  const defaultHotkeys = {
    "copy link": "l",
    copy: "c",
    cut: "t",
    paste: "p",
    "add to basket": "a",
    "advanced download": "d",
    quickview: "q",
    share: "s",
  };

  let response = [];
  let usedChars = new Set();
  for (const str of strings) {
    let hotkey = "";
    const prefix = defaultHotkeys[str];
    if (prefix) {
      hotkey = prefix;
      if (!usedChars.has(prefix)) {
        usedChars.add(prefix);
      } else {
        for (let key in defaultHotkeys) {
          if (defaultHotkeys[key] === prefix) {
            const match = response.find(
              (item) => item.hotkey === prefix && item.buttonName !== key
            );
            if (match) match.hotkey = "";
            break;
          }
        }
      }
    } else {
      let firstLetter = str[0];
      let index = 1;
      while (
        usedChars.has(firstLetter) &&
        index < str.length &&
        !firstLetter.match(/[a-zA-Z0-9]/)
      ) {
        firstLetter = str[index];
        index++;
      }
      if (!usedChars.has(firstLetter) && firstLetter.match(/[a-zA-Z0-9]/)) {
        hotkey = firstLetter;
        usedChars.add(firstLetter);
      } else {
        for (let char of str) {
          if (!usedChars.has(char) && char.match(/[a-zA-Z0-9]/)) {
            hotkey = char;
            usedChars.add(char);
            break;
          }
        }
      }
    }
    response.push({ buttonName: str, hotkey });
  }
  return response;
};

function addHotkeySpan(inputString, hotkey) {
  const lowerCaseString = inputString.toLowerCase();

  if (hotkey && hotkey !== "") {
    const hotkeyIndex = lowerCaseString.indexOf(hotkey);
    const hotkeyChar =
      hotkeyIndex !== -1 ? inputString.charAt(hotkeyIndex) : "";
    const hotkeySpan = `<span class="hotkey">${hotkeyChar}</span>`;
    const result = inputString.replace(hotkeyChar, hotkeySpan);
    return result;
  } else {
    return inputString;
  }
}

const writePrivs = ["changeicon", "updatekeywords", "unzip"];

const replaceCustomPrivs = (priv) => {
  if (readPrivs.includes(priv)) return "read";
  if (writePrivs.includes(priv)) return "write";
  return priv;
};

const contains = (str, word) => str.toLowerCase().includes(word);

const hasBasketMenu = (data) => {
  for (const obj of data) {
    for (const [key, value] of Object.entries(obj)) {
      if (
        contains(key, "basket") ||
        (typeof value === "string" && contains(value, "basket"))
      ) {
        return true;
      }
    }
  }
  return false;
};

export default menubar = {
  highlightPaste: (un) => {
    const container = _$("#user-buttons").el();
    container
      .querySelectorAll("[data-command=\"performAction('paste');\"]")
      .forEach((element) => {
        if (un) {
          element.classList.remove("highlight");
        } else {
          element.classList.add("highlight");
        }
      });
  },
  getContextMenuItems: (privs) => {
    const navbarButtons = [];
    const { userInfo } = store;
    if (userInfo && userInfo.buttons && userInfo.buttons.buttons_subitem) {
      const buttons = userInfo.buttons.buttons_subitem;
      let currentPerms = (privs || "(read)").toLowerCase();

      if (buttons) {
        let currentGroup;
        let groupSubItems = [];

        const removeCopyLink = utils.getUserCustomizationValue(
          "noCopyLinkOnContextMenu"
        );

        const buttonNames = [];
        const enableHotkeys = utils.getUserCustomizationValue("enableHotkeys");

        if (enableHotkeys) {
          buttons.forEach((button, i) => {
            if (button.key.includes("(delete)")) {
              return;
            }

            let keyValue = button.key.substring(
              button.key.indexOf(":") + 1,
              button.key.length
            );
            buttonNames.push(keyValue.toLowerCase());
          });
        }

        const hotKeys = getHotkeys(buttonNames);

        buttons.forEach((button, i) => {
          const { key, value, for_context_menu, isgroupRoot, isSubItem } =
            button;

          if (removeCopyLink && key === "(copyDirectLink):Copy Link") return;

          let { requiredPriv } = button;
          let keyValue = key.substring(1, key.indexOf(":") - 1);
          if (keyValue) keyValue = keyValue.toLowerCase().replace(/ /g, "");
          if (keyValue == "slideshow" && key.indexOf("quickView") > 0)
            keyValue = "quickview";
          if (typeof requiredPriv !== "string") {
            // Old logic for required privs
            // requiredPriv = keyValue;

            // New
            requiredPriv = "";
          }

          if (
            key?.toLowerCase()?.includes("share") &&
            !currentPerms?.includes("(share)")
          ) {
            return;
          }

          if (
            key === "(write):Edit file (for context menu only)" &&
            !currentPerms?.includes("(write)")
          ) {
            return;
          }

          let label = key.substring(key.indexOf(":") + 1, key.length);
          let customImageUrl = null;
          if (label.includes("##") && label.match(/##(.*?)##/)) {
            const match = label.match(/##(.*?)##/);
            customImageUrl = match ? match[1] : null;
            label = label.replace(/##.*?##/, "").trim();
          }

          const hotKey = hotKeys.find(
            (item) => item?.buttonName === label?.toLowerCase()
          );
          const hotKeyHTML = enableHotkeys
            ? addHotkeySpan(label, hotKey?.hotkey)
            : null;

          requiredPriv = replaceCustomPrivs(requiredPriv);
          const isGroupRoot = isgroupRoot == "true";
          const isGroupSubItem = isSubItem == "true";
          const lastItem = i === buttons.length - 1;
          let link = value.replace(/\"/g, "'");
          const extLink = link.endsWith(":external");
          const isLink = !link.startsWith("javascript:");
          link = link.replace(":external", "");
          link = link.replace("javascript:", "");
          if (link.indexOf("javascript:customFileAction_") == 0) {
            let method = link.split("_")[1].split("(")[0];
            link = link
              .replace("_" + method, "")
              .replace("customFileAction", "customFileActionProxy")
              .replace("()", "('" + method + "')");
          }
          if (isGroupRoot) {
            currentGroup = {
              link,
              tabindex: i,
              i18nkey: label,
              title: t(label),
              iconClass: `icon-${icons[keyValue] || icons.default}`,
              children: "",
              key,
              customImageUrl,
            };
            groupSubItems = [];
          } else {
            if (for_context_menu === "true") {
              if (currentGroup && !isGroupSubItem) {
                navbarButtons.push({
                  ...currentGroup,
                  subMenu: [...groupSubItems],
                  index: i,
                });
                currentGroup = null;
                groupSubItems = [];
              }
              if (currentGroup && isGroupSubItem) {
                groupSubItems.push({
                  iconClass: `icon-${icons[keyValue] || icons.default}`,
                  customImageUrl,
                  i18nkey: label,
                  title: t(label),
                  command: link,
                  isLink,
                  target: extLink ? 'data-target="_blank"' : "",
                  link: isLink ? link : "#/",
                  tabindex: i,
                  requiredPriv,
                  key,
                  hotKeyHTML,
                });
                if (currentGroup && lastItem) {
                  navbarButtons.push({
                    ...currentGroup,
                    subMenu: [...groupSubItems],
                    index: i,
                  });
                  currentGroup = null;
                  groupSubItems = [];
                }
              } else {
                navbarButtons.push({
                  iconClass: `icon-${icons[keyValue] || icons.default}`,
                  customImageUrl,
                  i18nkey: label,
                  title: t(label),
                  command: link,
                  isLink,
                  target: extLink ? 'data-target="_blank"' : "",
                  link: isLink ? link : "#/",
                  tabindex: i,
                  requiredPriv,
                  key,
                  hotKeyHTML,
                });
              }
            }
          }
        });
      }
    }
    return navbarButtons;
  },
  //Render main navigation buttons and context menu items
  render: ({ cb = utils.noop, onclick = utils.noop }) => {
    const { userInfo, currentDirectoryInfo, copiedItems } = store;
    const privs =
      typeof userInfo.user_priv_options === "string"
        ? userInfo.user_priv_options
        : "";
    const isAdmin = privs && privs.toLowerCase().indexOf("(connect)") >= 0;
    if (userInfo && userInfo.buttons && userInfo.buttons.buttons_subitem) {
      const copyAvailable =
        copiedItems && copiedItems.items && copiedItems.items.length > 0;
      const buttons = userInfo.buttons.buttons_subitem;
      const hideBasket = !hasBasketMenu(buttons);
      if (hideBasket) {
        _$("#basket_icon").hide();
      }
      const container = _$("#user-buttons");
      if (utils.cache.get("uploadOnly")) {
        //No buttons for upload only
        return;
      } else if (utils.cache.get("listingPageShown")) {
        // $("#mainNavigation").hide();
        // Hide menu bar
        return;
      }
      /**Todo: Remove all except default buttons */
      // container
      //   .find("a[href!='javascript:doLogout();']", true)
      //   .parent()[0]
      //   .remove();
      let currentPerms = (currentDirectoryInfo.privs || "(read)").toLowerCase();
      if (isAdmin) {
        currentPerms += "(admin)";
      }
      /**Todo: For search just apply read privs */
      // if ($("#searchResultNotification").attr("search")) currentPerms += "(read)";
      let comment = utils.getPermissionData(currentPerms, "comment");
      if (comment && currentPerms.indexOf("(inherited)") < 0) {
        comment = utils.decodeURILocal(comment);
        comment = comment.replace(/\#LPR#/g, "(").replace(/\#RPR#/g, ")");
        /**Todo: Show folder comments */
        // $("#comments").empty().html(DOMPurify.sanitize(comment)).show();
      } else {
        // $("#comments").hide();
      }

      /**Todo: Hide buttons if no buttons available */
      // let mainNav = $("#mainNavigation").hide();
      if (buttons) {
        //Loop through menu item and make a button list

        let navbarButtons = [];
        let currentGroup;
        let groupSubItems = [];

        const hideMenuBarIcon = utils.getUserCustomizationValue(
          "dontShowButtonsInMainMenu"
        );

        const buttonNames = [];

        const enableHotkeys = utils.getUserCustomizationValue("enableHotkeys");

        if (enableHotkeys) {
          buttons.forEach((button, i) => {
            if (button.key.includes("(delete)")) {
              return;
            }

            let keyValue = button.key.substring(
              button.key.indexOf(":") + 1,
              button.key.length
            );
            buttonNames.push(keyValue.toLowerCase());
          });
        }

        const hotKeys = getHotkeys(buttonNames);

        buttons.forEach((button, i) => {
          const { key, value, for_menu, isgroupRoot, isSubItem } = button;
          let { requiredPriv } = button;
          let val = key.substring(1, key.indexOf(":") - 1);
          if (val) val = val.toLowerCase().replace(/ /g, "");
          if (val == "slideshow" && key.indexOf("quickView") > 0)
            val = "quickview";
          if (typeof requiredPriv !== "string") {
            // Old logic for required privs
            // requiredPriv = val;

            // New
            requiredPriv = "";
          }

          if (
            key?.toLowerCase()?.includes("share") &&
            !currentPerms?.includes("(share)")
          ) {
            return;
          }

          if (key === "(write):Edit file (for context menu only)") {
            return;
          }

          requiredPriv = replaceCustomPrivs(requiredPriv);
          const isGroupRoot = isgroupRoot == "true";
          const isGroupSubItem = isSubItem == "true";
          const lastItem = i === buttons.length - 1;
          let label = key.substring(key.indexOf(":") + 1, key.length);
          let customImageUrl = null;
          if (label.includes("##") && label.match(/##(.*?)##/)) {
            const match = label.match(/##(.*?)##/);
            customImageUrl = match ? match[1] : null;
            label = label.replace(/##.*?##/, "").trim();
          }

          let link = value.replace(/\"/g, "'");
          const extLink = link.endsWith(":external");
          const isLink = !link.startsWith("javascript:");
          link = link.replace(":external", "");
          link = link.replace("javascript:", "");

          const hotKey = hotKeys.find(
            (item) => item?.buttonName === label?.toLowerCase()
          );
          const hotKeyHTML = enableHotkeys
            ? addHotkeySpan(label, hotKey?.hotkey)
            : null;

          if (link.indexOf("javascript:customFileAction_") == 0) {
            let method = link.split("_")[1].split("(")[0];
            link = link
              .replace("_" + method, "")
              .replace("customFileAction", "customFileActionProxy")
              .replace("()", "('" + method + "')");
          }
          if (isGroupRoot) {
            currentGroup = {
              customImageUrl,
              link,
              tabindex: i,
              icon: icons[val] || icons.default,
              children: "",
              label: t(label),
              i18nkey: label,
            };
            groupSubItems = [];
          } else {
            if (for_menu === "true") {
              if (currentGroup && !isGroupSubItem) {
                navbarButtons.push(
                  topNavButtonGroupRootTemplate({
                    hideMenuBarIcon,
                    ...currentGroup,
                    children: groupSubItems.join(""),
                    index: i,
                    key,
                  })
                );
                currentGroup = null;
                groupSubItems = [];
              }
              if (currentGroup && isGroupSubItem) {
                // text = crushFTPTools.htmlEncode(text);
                if (
                  !currentPerms ||
                  !requiredPriv ||
                  currentPerms.indexOf(requiredPriv) >= 0 ||
                  key.toString().indexOf("(custom):") == 0
                ) {
                  groupSubItems.push(
                    topNavButtonTemplate({
                      hideMenuBarIcon,
                      command: link,
                      isLink,
                      target: extLink ? 'data-target="_blank"' : "",
                      link: isLink ? link : "#/",
                      tabindex: i,
                      i18nkey: label,
                      label: t(label),
                      icon: icons[val] || icons.default,
                      key,
                      hotKeyHTML,
                      customImageUrl,
                    })
                  );
                }
                if (currentGroup && lastItem) {
                  navbarButtons.push(
                    topNavButtonGroupRootTemplate({
                      ...currentGroup,
                      customImageUrl,
                      hideMenuBarIcon,
                      children: groupSubItems.join(""),
                      index: i,
                      key,
                    })
                  );
                  currentGroup = null;
                  groupSubItems = [];
                }
              } else if (
                !currentPerms ||
                !requiredPriv ||
                currentPerms.indexOf(requiredPriv) >= 0 ||
                key.toString().indexOf("(custom):") == 0
              ) {
                navbarButtons.push(
                  topNavButtonTemplate({
                    command: link,
                    isLink,
                    target: extLink ? 'data-target="_blank"' : "",
                    link: isLink ? link : "#/",
                    tabindex: i,
                    i18nkey: label,
                    label: t(label),
                    icon: icons[val] || icons.default,
                    key,
                    hideMenuBarIcon,
                    hotKeyHTML,
                    customImageUrl,
                  })
                );
              } else {
                //console.log(requiredPriv, currentPerms);
              }
            }
          }
        });
        container.html(navbarButtons.join(""));

        const { username } = store.userInfo;

        if (username) {
          const loginUserButton = container.find("a[meta='(login):Login']");
          loginUserButton.remove();
        } else {
          const logoutUserButton = container.find("a[meta='(logout):Logout']");
          logoutUserButton.remove();
        }

        container
          .find("a")
          .sel()
          .forEach((button) => {
            const target = button.getAttribute("data-target");
            if (target) {
              button.setAttribute("target", target);
            }
            _$(button).on("click", (evt) => {
              onclick.call(this, evt, button);
            });
          });
        if (copyAvailable) {
          menubar.highlightPaste();
        }
      }
    }
  },
};
